import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, LoadingController, AlertController } from '@ionic/angular';
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';


//import 'rxjs/add/operator/map';
//import 'rxjs/Rx';


@Injectable({
  providedIn: 'root'
})
export class PortalService {

  constructor(public http: HttpClient, public plt: Platform, public loading: LoadingController) {

  }


  result: any;
  baseURL: any = "https://exchageapi.miuegypt.edu.eg/api/Exchange/";
  //baseURL: any = "http://localhost:15493/api/Exchange/";


  GetAllCountries() {
    return this.CallPortalGet('GetAllCountries');
  }

  GetAllFaculties() {
    return this.CallPortalGet('GetAllFaculties');
  }

  GetAllUniversities() {
    return this.CallPortalGet('GetAllUniversities');
  }

  GetAllSemesters() {
    return this.CallPortalGet('GetAllSemesters');
  }

  CheckEmailExist(email: any) {
    return this.CallPortalGet('CheckEmailExist?email=' + email);
  }

  CheckPassportExist(passport: any) {
    return this.CallPortalGet('CheckPassportExist?passport=' + passport);
  }

  SaveStudentData(item: any) {
    return this.CallPortalPost('SaveStudentData', item);
  }


  CallPortalGet(methodURL: string) {
    return this.CallPortalGet_base(this.baseURL, methodURL);
  }


  CallPortalGet_base(baseURL: string, methodURL: string) {
    return new Promise(resolve => {
      this.http.get(baseURL + methodURL)

        .subscribe(data => {
          this.result = data;
          resolve(this.result);
        }, Error => {
          console.error(Error);
          resolve(Error);
        });
    });
  }


  CallPortalPost(methodURL: string, obj: any) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + methodURL, obj).pipe(
        map(res => res))
        .subscribe(data => {
          this.result = data;
          resolve(this.result);
        }, Error => {
          console.error(Error);
          resolve(Error);
        });
    });
  }


}


@Injectable()
export class FilterPipe {

  transform(value: any, args?: any): any {
    var unique = {};
    var uniqueList = [];
    for (var i = 0; i < value.length; i++) {
      if (typeof unique[value[i][args]] == "undefined") {
        unique[value[i][args]] = "";
        uniqueList.push(value[i]);
      }
    }
    return uniqueList;
  }

}


@Injectable()
export class Utils {

  constructor(public alertCtrl: AlertController, public platform: Platform, public loading: LoadingController, public router: Router) { }

  CloseApp() {
    navigator['app'].exitApp();
  }


  PresentConnectionErrorAlert(retryFun: Function) {
    var here = this;
    this.Present2ButtonsAlert('Error', 'Connection Error', 'Exit', function () { here.CloseApp(); }, 'Retry', retryFun);
  }

  PresentErrorAlert(retryFun: Function) {
    var here = this;
    this.Present2ButtonsAlert('Error', 'Error, Please Try again Later', 'Exit', function () { here.CloseApp(); }, 'Retry', retryFun);
  }

  async Present2ButtonsAlert(title: string, message: string, button1: string, button1Func: Function, button2: string, button2Func: Function) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: button1,
          handler: () => {
            button1Func();
          }
        },
        {
          text: button2,
          handler: () => {
            button2Func();
          }
        }
      ]
    });
    alert.present();
  }


  PresentExitAlert(title: string, message: string) {
    var here = this;
    this.PresentButtonAlert(title, message, 'Close', function () { here.CloseApp(); });
  }

  async PresentButtonAlert(title: string, message: string, button1: string, button1Func: Function) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: [
        {
          text: button1,
          handler: () => {
            button1Func();
          }
        }
      ]
    });
    alert.present();
  }

  async PresentOkAlert(title: string, message: string) {
    let alert = await this.alertCtrl.create({
      header: title,
      message: message,
      buttons: ['Ok']
    });
    alert.present();
  }
}
